var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3 -0.00585938H495.7V341.994H17.3V-0.00585938Z",
    fill: "#181A93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H513V113.994H0V-0.00585938Z",
    fill: "#FFA44A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 227.994H513V341.994H0V227.994Z",
    fill: "#1A9F0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 113.994H513V227.994H0V113.994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 205.194C275.388 205.194 290.7 189.882 290.7 170.994C290.7 152.106 275.388 136.794 256.5 136.794C237.612 136.794 222.3 152.106 222.3 170.994C222.3 189.882 237.612 205.194 256.5 205.194Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 216.594C231.4 216.594 210.9 196.094 210.9 170.994C210.9 145.894 231.4 125.394 256.5 125.394C281.6 125.394 302.1 145.894 302.1 170.994C302.1 196.094 281.6 216.594 256.5 216.594ZM256.5 205.194C274.7 205.194 290.7 189.194 290.7 170.994C290.7 152.794 274.8 136.794 256.5 136.794C238.2 136.794 222.3 152.794 222.3 170.994C222.3 189.194 238.3 205.194 256.5 205.194Z",
    fill: "#181A93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 193.794C269.092 193.794 279.3 183.586 279.3 170.994C279.3 158.402 269.092 148.194 256.5 148.194C243.908 148.194 233.7 158.402 233.7 170.994C233.7 183.586 243.908 193.794 256.5 193.794Z",
    fill: "#181A93"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_989"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/IN.1197ba2c6f61d9b5f583e69f921bce10.svg";
export { ForwardRef as ReactComponent };